// Visual "in progress" feedback for CF7 forms: while the AJAX submission is
// in flight, disable the submit button and swap its label so the page
// doesn't appear to hang before the result shows.
//
// Driven by the "submitting" class CF7 core toggles on the <form> element
// itself (the same signal the built-in spinner relies on) via a
// MutationObserver, rather than the wpcf7beforesubmit/wpcf7submit custom
// events — those are dispatched from inside CF7's fetch chain and proved
// unreliable to hook into directly.
//
// The bt-form-validation plugin hides the real input.wpcf7-submit (display:
// none) and inserts a visible <button class="fv-active-button"> clone next
// to it — that's the element users actually see and click, so it has to be
// the one whose label/disabled state gets updated, not the hidden original.
const CF7_SENDING_LABEL = "Sending...";

function getVisibleSubmitButton(form) {
  return (
    form.querySelector(".fv-active-button") ||
    form.querySelector(".wpcf7-submit")
  );
}

function setButtonLabel(btn, label) {
  if (btn.tagName === "INPUT") {
    btn.value = label;
  } else {
    btn.textContent = label;
  }
}

function getButtonLabel(btn) {
  return btn.tagName === "INPUT" ? btn.value : btn.textContent;
}

function setSubmitLoading(form, isLoading) {
  const submitBtn = getVisibleSubmitButton(form);
  if (!submitBtn) {
    return;
  }

  if (isLoading) {
    if (submitBtn.dataset.originalValue === undefined) {
      submitBtn.dataset.originalValue = getButtonLabel(submitBtn);
    }
    setButtonLabel(submitBtn, CF7_SENDING_LABEL);
    submitBtn.disabled = true;
  } else {
    if (submitBtn.dataset.originalValue !== undefined) {
      setButtonLabel(submitBtn, submitBtn.dataset.originalValue);
      delete submitBtn.dataset.originalValue;
    }
    submitBtn.disabled = false;
  }
}

function watchForm(form) {
  let isSubmitting = form.classList.contains("submitting");

  new MutationObserver(() => {
    const nowSubmitting = form.classList.contains("submitting");
    if (nowSubmitting !== isSubmitting) {
      isSubmitting = nowSubmitting;
      setSubmitLoading(form, isSubmitting);
    }
  }).observe(form, { attributes: true, attributeFilter: ["class"] });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("form.wpcf7-form").forEach(watchForm);
});
